<template>
    <ElPagination
      v-bind="$attrs"
      class="large centre"
      background
      v-on="$listeners"
      layout="prev, pager, next"
    />
</template>
<script>
export default {
  name: 'SElPagination',
  description: 'Custom wrapper for Element Pagination to provide defaults we use throughout the app.',
  inheritAttrs: false, // Allows us to act as a passthrough to child component
};
</script>
